import { render } from "./CopyToClipboard.vue?vue&type=template&id=a0c1fb86&scoped=true"
import script from "./CopyToClipboard.vue?vue&type=script&lang=js"
export * from "./CopyToClipboard.vue?vue&type=script&lang=js"

import "./CopyToClipboard.vue?vue&type=style&index=0&id=a0c1fb86&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0c1fb86"]])

export default __exports__